export default __webpack_public_path__ + "static/media/couch.08e39017.jpg";